import axios from 'axios';

class AuthService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || 'https://portalrelacionamentoapi.dev-gam.com';
        this.credentials = {
            login: 'api.pr.gam',
            senha: '@p1.P0rt4l.R31@ci0n4mEnt0'
        };
        this.token = null;
        this.portalToken = null;
    }

    // M�todo para autenticar e obter o token
    async login() {
        try {
            const response = await axios.post(`${this.apiUrl}/auth`, this.credentials);
            this.token = response.data.token;
            //console.log(this.token);
            return this.token;
        } catch (error) {
            console.error('Erro ao autenticar:', error);
            throw new Error('Erro ao autenticar. Verifique suas credenciais.');
        }
    }

    async hmac(token) {
        try {
            const response = await axios.post(`${this.apiUrl}/auth/hmac/decode/${token}`);
            const cliente = response.data.cdCliente;
            //console.log('realizando o HMAC no endere�o:' + this.apiUrl);
            //console.log(cliente);
            return cliente;
        } catch (error) {
            console.error('Erro ao teste:', error);
            throw new Error('Erro ao teste. Verifique suas credenciais.');
        }
    }

    // M�todo para obter o token
    getToken() {
        return this.token;
    }

    // Token do usu�rio logado via multi-acesso (login/senha), quando existir.
    setPortalToken(token) {
        this.portalToken = token;
    }

    // Indica se a sess�o atual � a de multi-acesso (login/senha). Consultado no lugar do estado
    // React `portalSession`, que só é atualizado no próximo render — logo após o login,
    // `setPortalToken` já rodou, mas o estado ainda não, e o log de acesso precisa acertar isso
    // já na primeira seleção de cliente pós-login.
    hasPortalToken() {
        return !!this.portalToken;
    }

    // Token usado nas chamadas �s APIs de dados: o do portal quando h� sess�o
    // de multi-acesso, caindo para o token da conta de servi�o (fluxo antigo
    // por token na URL) quando n�o h�.
    getActiveToken() {
        return this.portalToken || this.token;
    }

    // Logout do usuário do portal: remove o token de portal da memória para que
    // nenhuma chamada seguinte reutilize a sessão encerrada.
    clearPortalToken() {
        this.portalToken = null;
    }
}

export default new AuthService();
